import { ChangeDetectionStrategy, Component, input } from '@angular/core';

/**
 * R-FORM-03 — label above input. Optional `required` adds amber asterisk; `hint` appends
 * inline muted text (e.g. "optional"). The `for` input wires the native `<label for>`/input id pair.
 */
@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'bodyanalytics-field-label',
  standalone: true,
  templateUrl: './field-label.component.html',
  styleUrls: ['./field-label.component.scss'],
})
export class FieldLabelComponent {
  readonly for = input.required<string>();
  readonly text = input.required<string>();
  readonly required = input<boolean>(false);
  readonly hint = input<string | undefined>(undefined);
}
